<div
  *ngIf="session && step as current"
  class="tt-page-guide"
  role="dialog"
  aria-modal="true"
  aria-labelledby="page-guide-title"
>
  <div class="tt-page-guide__dim" [style.top.px]="dimTop.top" [style.left.px]="dimTop.left" [style.width.px]="dimTop.width" [style.height.px]="dimTop.height"></div>
  <div class="tt-page-guide__dim" [style.top.px]="dimLeft.top" [style.left.px]="dimLeft.left" [style.width.px]="dimLeft.width" [style.height.px]="dimLeft.height"></div>
  <div class="tt-page-guide__dim" [style.top.px]="dimRight.top" [style.left.px]="dimRight.left" [style.width.px]="dimRight.width" [style.height.px]="dimRight.height"></div>
  <div class="tt-page-guide__dim" [style.top.px]="dimBottom.top" [style.left.px]="dimBottom.left" [style.width.px]="dimBottom.width" [style.height.px]="dimBottom.height"></div>
  <div
    class="tt-page-guide__shield"
    [style.top.px]="spot.top"
    [style.left.px]="spot.left"
    [style.width.px]="spot.width"
    [style.height.px]="spot.height"
  ></div>
  <div
    class="tt-page-guide__frame"
    [style.top.px]="spot.top"
    [style.left.px]="spot.left"
    [style.width.px]="spot.width"
    [style.height.px]="spot.height"
  ></div>

  <div
    #card
    class="tt-page-guide__card"
    [class.tt-page-guide__card--ready]="placed"
    [style.top.px]="callout.top"
    [style.left.px]="callout.left"
    [style.width.px]="callout.width || null"
    tabindex="-1"
  >
    <div class="tt-page-guide__head">
      <p class="tt-page-guide__kicker">{{ stepLabel }}</p>
      <button type="button" class="tt-page-guide__x" (click)="close()" aria-label="Zavřít">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 6l12 12M18 6L6 18"></path>
        </svg>
      </button>
    </div>
    <h2 id="page-guide-title" class="tt-page-guide__title">{{ current.title }}</h2>
    <p class="tt-page-guide__body">{{ current.body }}</p>
    <div class="tt-page-guide__nav">
      <button type="button" class="btn btn-ghost" (click)="close()">Zavřít</button>
      <div class="tt-page-guide__nav-main">
        <button type="button" class="btn btn-secondary" (click)="back()" [disabled]="isFirst">Zpět</button>
        <button #nextBtn type="button" class="btn btn-primary" (click)="next()">{{ isLast ? 'Hotovo' : 'Další' }}</button>
      </div>
    </div>
  </div>
</div>
